import { themeColors } from "../../config.js";
export const menuStyles = {
  bar: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: 50,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: themeColors.transparentBlack,
    fontFamily: "roboto",
  },
  logOutBtn: {
    padding: 5,
    borderRadius: 5,
    margin: 10,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: themeColors.transparentWhite,
  },
};
